import { createMakeStyles } from 'tss-react'
import useTheme from 'd2/hooks/useTheme'

export type { CSSObject } from 'tss-react'
const { makeStyles } = createMakeStyles({ useTheme })
export default makeStyles
